import { PropsWithChildren } from "react";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import FeatureGates from "@atlaskit/feature-gate-js-client";

import { getReCaptchaKey, isProduction } from "@/components/signup/utils";

export const SmartReCaptcha = ({ children }: PropsWithChildren) => {
    const RECAPTCHA_KEY = "6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD";
    const RECAPTCHA_KEY_TEST = "6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN";
    if (FeatureGates.checkGate("wac-recaptcha-flag")) {
        const key = isProduction() ? RECAPTCHA_KEY : RECAPTCHA_KEY_TEST;
        return (
            <GoogleReCaptchaProvider
                reCaptchaKey={key}
                useEnterprise={true}
                useRecaptchaNet={true}
                scriptProps={{
                    async: true
                }}
            >
                {children}
            </GoogleReCaptchaProvider>
        );
    } else {
        return (
            <GoogleReCaptchaProvider
                reCaptchaKey={getReCaptchaKey()}
                useEnterprise={true}
                useRecaptchaNet={true}
                scriptProps={{
                    async: true
                }}
            >
                {children}
            </GoogleReCaptchaProvider>
        );
    }
};
